<template>
  <div id="SectionFooter" class="not-full">
    <div class="section__terms">
      <router-link
        :to="{
          name: 'terms/detail',
          params: { code: 'privacy' }
        }"
      >
        개인정보처리취급방침
      </router-link>
      <router-link
        :to="{
          name: 'terms/detail',
          params: { code: 'onto' }
        }"
      >
        온라인연계대출계약 약관
      </router-link>
    </div>
    <ul>
      <li class="content">
        <b>(주)펀다 대표 박성준</b><br />
        <span>서울 서초구 사평대로53길 30 메이크잇 203호 ,204호</span><br />
        사업자등록번호 724-87-00107<br />
        온라인투자연계금융업 2022-금융위원회-18
      </li>
      <li class="content">
        대출금리 연 최고 17.9% 이내, 연체이자율 : 약정금리 +3% (법정최고금리
        20%이내), 플랫폼 이용료 외 취급수수료 등 기타 부대비용은 없음,
        조기상환조건 없음
      </li>
      <li class="content">
        <b
          >중개수수료를 요구하거나 받는 행위는 불법입니다.<br />
          대출 시 귀하의 신용평점이 하락할 수 있습니다.<br />
          과도한 빚은 당신에게 큰 불행을 안겨줄 수 있습니다.</b
        >
      </li>
      <li class="content">
        (주)펀다에서 제공하는 펀다나우는 자영업자 마이너스통장, 샵포터즈 서비스를 함께 제공하고 있습니다.
      </li>
    </ul>
    <div class="call">
      <a href="tel:02-6925-1788">대표번호 02-6925-1788</a>
    </div>
    <div class="copyright">Copyright © FUNDA 2020. All Right Reserved.</div>
  </div>
</template>

<script>
export default {
  name: 'SectionFooter',
}
</script>

<style lang="scss" scoped>
#SectionFooter {
  display: block;
  float: left;
  padding-top: 40px;
  padding-bottom: 133px;
  background-color: #f5f5f5;
  ul {
    width: 100%;
    float: left;
    padding: 0;
    margin: 0;
    li {
      display: block;
      float: left;
      width: 100%;
      margin-bottom: 18px;
    }
  }

  .content {
    display: block;
    float: left;
    font-size: 13px;
    line-height: 1.43;
    letter-spacing: -0.27px;
    color: #727d8c;
    b {
      font-weight: 900;
    }
    span {
      letter-spacing: -0.9px;
    }
  }

  .call {
    font-weight: 900;
    font-size: 16px;
    line-height: 1.25;
    color: #727d8c;
    margin-top: 20px;
  }

  .copyright {
    font-size: 13px;
    line-height: 1.54;
    color: #727d8c;
    margin-top: 5px;
  }

  a {
    color: #727d8c;
    text-decoration: none;
  }

  .section__terms {
    margin-bottom: 15px;

    a {
      font-weight: 900;
      letter-spacing: -0.3px;
    }

    a:not(:last-child) {
      margin-right: 5px;
    }
  }
}
</style>
